import { render } from "./partnerTableSet.vue?vue&type=template&id=d20a99a8&scoped=true"
import script from "./partnerTableSet.vue?vue&type=script&lang=js"
export * from "./partnerTableSet.vue?vue&type=script&lang=js"

import "./partnerTableSet.vue?vue&type=style&index=0&id=d20a99a8&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20a99a8"]])

export default __exports__